import { FC, Props } from "./typings";
import Chip from "components/Chip";
import Placeholder from "assets/placeholder.png";

const UserBadge: FC<Props> = ({
  label,
  onRemove,
}) => {
  return (
    <Chip
      className={{
        background: "red !important",
      }}
      small={true}
      element={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <img src={Placeholder} />

          {label}
        </div>
      }
      onDelete={
        onRemove
          ? () => {
              onRemove();
            }
          : undefined
      }
    />
  );
};

export default UserBadge;
